<template>
  <router-view
    slot="content"
    class="content"
    data-test="sennTMS-shell-content"
  />
</template>
